module.exports = __webpack_public_path__ + "static/media/cbr-logo@3x.97207881.png";